// @flow

import type {Effect} from '../../types'

import {
  take,
  put,
  call,
} from 'redux-saga/effects'
import {
  actionTypes as routerTypes,
} from 'redux-router5'

import {fetchServiceProvider} from '../lib/fetchServiceProvider'
import {placeActions} from '../actions'
import {hideMap} from '../../map/lib/hideMap'

export function* enterPlaceDetailEffect(): Effect {
  while (true) {
    const {payload: {route}} = yield take(routerTypes.TRANSITION_SUCCESS)
    if (route.name === 'place-detail') {
      try {
        yield put(placeActions.setPlace(null))
        yield call(hideMap)
        const place: ServiceProvider = yield call(fetchServiceProvider, route.params.place)
        yield put(placeActions.setPlace(place))
      } catch (error) {
        console.log(error)
      }
    }
  }
}
